
import * as CookieConsent from "vanilla-cookieconsent";

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,
        };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'cookie-consent-config';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.init();
    }

    init(){
        //console.log( CookieConsent );

        // Enable dark mode
        document.documentElement.classList.add('cc--darkmode');

        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "box wide",
                    position: "bottom center",
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false
                }
            },
            categories: {
                necessary: {
                    readOnly: true
                },
                preferences: { 
                    readOnly: false,
                    autoClear: {
                        cookies: [
                            {
                                name: 1 // /^(_ga)/      //regex
                            }
                        ]
                    }
                },
                marketing: { 
                    readOnly: false,
                    autoClear: {
                        cookies: [
                            {
                                name: /^(_ga)/
                            },
                            {
                                name: 'i/jot/embeds'
                            },
                            {
                                name: 'NID'
                            },
                        ]
                    }
                }
            },
            language: {
                default: "en",
                rtl: "ar",
                translations: {

                    en: {
                        consentModal: {
                            title: "ESCR-Net Cookie Settings",
                            description: "Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            footer: "<a href='\\privacy-policy'>Read our Privacy Policy</a>"
                        },
                        preferencesModal: {
                            title: "Consent Preferences",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            closeIconLabel: "Close modal",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
                                },
                                {
                                    title: "Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                    description: "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
                                    linkedCategory: "necessary",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: 'cc_cookie',
                                                domain: 'ESCR-Net',
                                                description: 'To store your cookies consent preferences.',
                                                duration: '182 days'
                                            },
                                            {
                                                name: '__cf_bm',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__cflb',
                                                domain: 'api2.hcaptcha.com',
                                                description: 'Registers which server-cluster is serving the visitor. This is used in context with load balancing, in order to optimize user experience.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__stripe_mid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: '__stripe_sid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__ab',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '__mf',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '_cfuvid',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is a part of the services provided by Cloudflare - Including load-balancing, deliverance of website content and serving DNS connection for website operators.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'CookieConsent',
                                                domain: 'escr-net.org',
                                                description: 'Stores the user\'s cookie consent state for the current domain.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'csrftoken',
                                                domain: 'instagram.com',
                                                description: 'Helps prevent Cross-Site Request Forgery (CSRF) attacks.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'hmt_id',
                                                domain: 'api.hcaptcha.com',
                                                description: 'This cookie is used to distinguish between humans and bots.',
                                                duration: '30 days'
                                            },
                                            {
                                                name: 'id',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'm',
                                                domain: 'm.stripe.com',
                                                description: 'Determines the device used to access the website. This allows the website to be formatted accordingly.',
                                                duration: '400 days'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Preferences Cookies",
                                    description: "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.",
                                    linkedCategory: "preferences",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '1',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is used in conjunction with the payment window - The cookie is necessary for making secure transactions on the website.',
                                                duration: 'session'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Marketing Cookies",
                                    description: "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
                                    linkedCategory: "marketing",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '/^(_ga)/',
                                                domain: 'Google Analytics',
                                                description: 'Used to send data to Google Analytics about the visitor\'s device and behavior. Tracks the visitor across devices and marketing channels.',
                                                duration: '2 years'
                                            },
                                            {
                                                name: 'i/jot/embeds',
                                                domain: 'twitter.com',
                                                description: 'Sets a unique ID for the visitor, that allows third party advertisers to target the visitor with relevant advertisement. This pairing service is provided by third party advertisement hubs, which facilitates real-time bidding for advertisers.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'NID',
                                                domain: 'google.com',
                                                description: 'Unclassified',
                                                duration: '6 months'
                                            }                                            
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "More information",
                                    description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href='\\contact'>contact us</a>."
                                }
                            ]
                        }
                    },

                    ar: {
                        consentModal: {
                            title: "ESCR-Net Cookie Settings",
                            description: "Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            footer: "<a href='\\privacy-policy'>Read our Privacy Policy</a>"
                        },
                        preferencesModal: {
                            title: "Consent Preferences",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            closeIconLabel: "Close modal",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
                                },
                                {
                                    title: "Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                    description: "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
                                    linkedCategory: "necessary",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: 'cc_cookie',
                                                domain: 'ESCR-Net',
                                                description: 'To store your cookies consent preferences.',
                                                duration: '182 days'
                                            },
                                            {
                                                name: '__cf_bm',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__cflb',
                                                domain: 'api2.hcaptcha.com',
                                                description: 'Registers which server-cluster is serving the visitor. This is used in context with load balancing, in order to optimize user experience.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__stripe_mid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: '__stripe_sid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__ab',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '__mf',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '_cfuvid',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is a part of the services provided by Cloudflare - Including load-balancing, deliverance of website content and serving DNS connection for website operators.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'CookieConsent',
                                                domain: 'escr-net.org',
                                                description: 'Stores the user\'s cookie consent state for the current domain.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'csrftoken',
                                                domain: 'instagram.com',
                                                description: 'Helps prevent Cross-Site Request Forgery (CSRF) attacks.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'hmt_id',
                                                domain: 'api.hcaptcha.com',
                                                description: 'This cookie is used to distinguish between humans and bots.',
                                                duration: '30 days'
                                            },
                                            {
                                                name: 'id',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'm',
                                                domain: 'm.stripe.com',
                                                description: 'Determines the device used to access the website. This allows the website to be formatted accordingly.',
                                                duration: '400 days'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Preferences Cookies",
                                    description: "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.",
                                    linkedCategory: "preferences",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '1',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is used in conjunction with the payment window - The cookie is necessary for making secure transactions on the website.',
                                                duration: 'session'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Marketing Cookies",
                                    description: "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
                                    linkedCategory: "marketing",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '/^(_ga)/',
                                                domain: 'Google Analytics',
                                                description: 'Used to send data to Google Analytics about the visitor\'s device and behavior. Tracks the visitor across devices and marketing channels.',
                                                duration: '2 years'
                                            },
                                            {
                                                name: 'i/jot/embeds',
                                                domain: 'twitter.com',
                                                description: 'Sets a unique ID for the visitor, that allows third party advertisers to target the visitor with relevant advertisement. This pairing service is provided by third party advertisement hubs, which facilitates real-time bidding for advertisers.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'NID',
                                                domain: 'google.com',
                                                description: 'Unclassified',
                                                duration: '6 months'
                                            }                                            
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "More information",
                                    description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href='\\contact'>contact us</a>."
                                }
                            ]
                        }
                    },


                    es: {
                        consentModal: {
                            title: "ESCR-Net Cookie Settings",
                            description: "Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            footer: "<a href='\\privacy-policy'>Read our Privacy Policy</a>"
                        },
                        preferencesModal: {
                            title: "Consent Preferences",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            closeIconLabel: "Close modal",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
                                },
                                {
                                    title: "Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                    description: "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
                                    linkedCategory: "necessary",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: 'cc_cookie',
                                                domain: 'ESCR-Net',
                                                description: 'To store your cookies consent preferences.',
                                                duration: '182 days'
                                            },
                                            {
                                                name: '__cf_bm',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__cflb',
                                                domain: 'api2.hcaptcha.com',
                                                description: 'Registers which server-cluster is serving the visitor. This is used in context with load balancing, in order to optimize user experience.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__stripe_mid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: '__stripe_sid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__ab',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '__mf',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '_cfuvid',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is a part of the services provided by Cloudflare - Including load-balancing, deliverance of website content and serving DNS connection for website operators.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'CookieConsent',
                                                domain: 'escr-net.org',
                                                description: 'Stores the user\'s cookie consent state for the current domain.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'csrftoken',
                                                domain: 'instagram.com',
                                                description: 'Helps prevent Cross-Site Request Forgery (CSRF) attacks.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'hmt_id',
                                                domain: 'api.hcaptcha.com',
                                                description: 'This cookie is used to distinguish between humans and bots.',
                                                duration: '30 days'
                                            },
                                            {
                                                name: 'id',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'm',
                                                domain: 'm.stripe.com',
                                                description: 'Determines the device used to access the website. This allows the website to be formatted accordingly.',
                                                duration: '400 days'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Preferences Cookies",
                                    description: "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.",
                                    linkedCategory: "preferences",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '1',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is used in conjunction with the payment window - The cookie is necessary for making secure transactions on the website.',
                                                duration: 'session'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Marketing Cookies",
                                    description: "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
                                    linkedCategory: "marketing",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '/^(_ga)/',
                                                domain: 'Google Analytics',
                                                description: 'Used to send data to Google Analytics about the visitor\'s device and behavior. Tracks the visitor across devices and marketing channels.',
                                                duration: '2 years'
                                            },
                                            {
                                                name: 'i/jot/embeds',
                                                domain: 'twitter.com',
                                                description: 'Sets a unique ID for the visitor, that allows third party advertisers to target the visitor with relevant advertisement. This pairing service is provided by third party advertisement hubs, which facilitates real-time bidding for advertisers.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'NID',
                                                domain: 'google.com',
                                                description: 'Unclassified',
                                                duration: '6 months'
                                            }                                            
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "More information",
                                    description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href='\\contact'>contact us</a>."
                                }
                            ]
                        }
                    },

                    fr: {
                        consentModal: {
                            title: "ESCR-Net Cookie Settings",
                            description: "Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            footer: "<a href='\\privacy-policy'>Read our Privacy Policy</a>"
                        },
                        preferencesModal: {
                            title: "Consent Preferences",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            closeIconLabel: "Close modal",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
                                },
                                {
                                    title: "Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                    description: "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
                                    linkedCategory: "necessary",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: 'cc_cookie',
                                                domain: 'ESCR-Net',
                                                description: 'To store your cookies consent preferences.',
                                                duration: '182 days'
                                            },
                                            {
                                                name: '__cf_bm',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__cflb',
                                                domain: 'api2.hcaptcha.com',
                                                description: 'Registers which server-cluster is serving the visitor. This is used in context with load balancing, in order to optimize user experience.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__stripe_mid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: '__stripe_sid',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: '1 day'
                                            },
                                            {
                                                name: '__ab',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '__mf',
                                                domain: 'stripe.com',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: '_cfuvid',
                                                domain: 'vimeo.com',
                                                description: 'This cookie is a part of the services provided by Cloudflare - Including load-balancing, deliverance of website content and serving DNS connection for website operators.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'CookieConsent',
                                                domain: 'escr-net.org',
                                                description: 'Stores the user\'s cookie consent state for the current domain.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'csrftoken',
                                                domain: 'instagram.com',
                                                description: 'Helps prevent Cross-Site Request Forgery (CSRF) attacks.',
                                                duration: '1 year'
                                            },
                                            {
                                                name: 'hmt_id',
                                                domain: 'api.hcaptcha.com',
                                                description: 'This cookie is used to distinguish between humans and bots.',
                                                duration: '30 days'
                                            },
                                            {
                                                name: 'id',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'm',
                                                domain: 'm.stripe.com',
                                                description: 'Determines the device used to access the website. This allows the website to be formatted accordingly.',
                                                duration: '400 days'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Preferences Cookies",
                                    description: "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.",
                                    linkedCategory: "preferences",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '1',
                                                domain: 'm.stripe.network',
                                                description: 'This cookie is used in conjunction with the payment window - The cookie is necessary for making secure transactions on the website.',
                                                duration: 'session'
                                            }
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "Marketing Cookies",
                                    description: "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
                                    linkedCategory: "marketing",
                                    cookieTable: {
                                        caption: 'List of cookies',
                                        headers: {
                                            name: 'Name',
                                            domain: 'From',
                                            description: 'Description',
                                            duration: 'Duration'
                                        },
                                        body: [
                                            {
                                                name: '/^(_ga)/',
                                                domain: 'Google Analytics',
                                                description: 'Used to send data to Google Analytics about the visitor\'s device and behavior. Tracks the visitor across devices and marketing channels.',
                                                duration: '2 years'
                                            },
                                            {
                                                name: 'i/jot/embeds',
                                                domain: 'twitter.com',
                                                description: 'Sets a unique ID for the visitor, that allows third party advertisers to target the visitor with relevant advertisement. This pairing service is provided by third party advertisement hubs, which facilitates real-time bidding for advertisers.',
                                                duration: 'session'
                                            },
                                            {
                                                name: 'NID',
                                                domain: 'google.com',
                                                description: 'Unclassified',
                                                duration: '6 months'
                                            }                                            
                                        ]
                                    }                                                                    
                                },
                                {
                                    title: "More information",
                                    description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href='\\contact'>contact us</a>."
                                }
                            ]
                        }                    
                    }
                },
                autoDetect: "document"
            }
        });


	}


    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
   }

}